export default class AccessRule {
  static 0 = 'Public'
  static 1 = 'Email verification'
  static 2 = 'Invitation only'
  static 3 = 'In-app authentication'
  static 4 = 'Paid access'
}
